'use client';
import { hideModal } from '@/redux/navigationSlice';
import { Button, Stack } from '@mui/material';
import { useRouter } from 'next/navigation';
import { useDispatch } from 'react-redux';

/**
 * Renders a back to store body for a Modal component with redirect logic.
 *
 * @return {React.JSX.Element} The rendered ModalCancelBody component.
 */
export const BackToStoreBody = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const router = useRouter();
  return (
    <>
      <Stack
        sx={{
          gap: 1,
          width: '100%',
          mt: 2,
        }}
      >
        {/* Staying is the primary action, as in mobile */}
        <Button onClick={() => dispatch(hideModal())}>Seguir</Button>
        <Button
          variant="inverted"
          onClick={() => {
            dispatch(hideModal());
            router.push('/back_to_store');
          }}
        >
          Volver a la tienda
        </Button>
      </Stack>
    </>
  );
};
